import { cloneElement, type ReactElement, type ReactNode } from "react";

/** A quiet "nothing here" line for a list in the sidebar, with an icon. */
export function EmptyNote({
  icon,
  children,
}: Readonly<{ icon: ReactElement<{ size?: number }>; children: ReactNode }>) {
  return (
    <p className="flex items-start gap-2 px-3 py-2 text-xs text-content-tertiary">
      <span className="grid h-4 shrink-0 place-items-center">{cloneElement(icon, { size: 14 })}</span>
      <span>{children}</span>
    </p>
  );
}
